import {
    put,
    race,
    take,
    takeLatest,
} from 'redux-saga/effects';
import actions from '@shared/actions';

function * standardFlow({payload}) {
    //show dialog
    yield put(actions.dialog.standard.show(payload));

    // wait for response
    const result = yield race({
        accept: take(actions.dialog.standard.accept.type),
        cancel: take(actions.dialog.standard.cancel.type),
    });

    //close dialog
    yield put(actions.dialog.standard.close());

    const accepted = yield Boolean(result.accept);
    if (accepted && result.accept && result.accept.payload.action) {
        yield put(result.accept.payload.action);
    } else if (!accepted && result.cancel && result.cancel.payload.action) {
        yield put(result.cancel.payload.action);
    }
}

export default function * actionWatcher() {
    yield takeLatest(actions.dialog.standard.start.type, standardFlow);
}

